var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSignUpIconUiFailure = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 60 60"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 617",
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#c70000"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M29.985 44a2.385 2.385 0 01-1.777-.723 2.459 2.459 0 01-.708-1.792 2.385 2.385 0 01.723-1.777A2.459 2.459 0 0130.015 39a2.385 2.385 0 011.777.723 2.459 2.459 0 01.708 1.792 2.385 2.385 0 01-.723 1.777 2.459 2.459 0 01-1.792.708zm0-10a2.392 2.392 0 01-1.777-.719A2.437 2.437 0 0127.5 31.5v-13a2.411 2.411 0 01.723-1.781A2.44 2.44 0 0130.015 16a2.392 2.392 0 011.777.719A2.437 2.437 0 0132.5 18.5v13a2.412 2.412 0 01-.723 1.781 2.441 2.441 0 01-1.792.719z",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/sign-up-icon-ui-failure.5b79b5db7e375f53145312c6c5632b1f.svg";
export { SvgSignUpIconUiFailure as ReactComponent };